import React from 'react'
import { Grid } from '@material-ui/core'
import WotcStep from './WotcStep'

const AdditionalStepsProvider = () => {
  return (
    <Grid container justifyContent='center' alignContent='center'>
      <WotcStep actSection='disclaimer' />
    </Grid>
  )
}

export default AdditionalStepsProvider
